<!--  -->
<template>
  <div v-loading="loading" class="asdarw_box">
    <el-form label-position="right" label-width="110px" :model="form">
      <el-form-item label="自有标题">
        <el-input
          v-model="form.sp_push_title"
          style="width: 300px"
          placeholder="请输入自有标题"
        />
      </el-form-item>
      <el-form-item label="类型">
        <el-button type="primary" size="mini">定时</el-button>
      </el-form-item>
      <el-form-item label="企业员工">
        <!-- <el-tag v-if="form.corp_userid!=''" style="margin-right:10px">{{ worker_name ? worker_name : '' }} ({{ form.corp_userid }}) </el-tag> -->
        <el-tag
          v-for="(items, index) in form.corp_userid"
          :key="index"
          style="margin-right: 10px"
          closable
          @close="handleClose(index)"
        >{{ items.name }}({{ items.corp_name }})
        </el-tag>
        <el-button
          type="primary"
          size="mini"
          @click="chorwe"
        >选择企业员工</el-button>
      </el-form-item>
      <el-form-item label="注">
        <div style="color: #f56c6c">
          不指定发表任务的执行者用户，则默认为企业全部用户
        </div>
      </el-form-item>
      <el-form-item v-if="form.corp_userid.length > 0" label="标签">
        <div
          style="
            margin-left: 20px;
            border-left: 1px solid #ccc;
            padding-left: 20px;
          "
        >
          <!-- 开关 -->
          <div style="display: flex; align-items: center">
            <div
              class="choiceofficialaccount"
              style="margin-bottom: 0; margin-right: 10px"
            >
              筛选标签组开关
            </div>
            <el-switch v-model="group_value" />
          </div>

          <!-- 多输入快捷筛选 -->
          <div
            v-if="group_value"
            style="margin: 10px 0; display: flex; align-items: center"
          >
            <el-input
              v-model="quickTagInput"
              placeholder="请输入标签名称，多个用逗号分隔"
              size="mini"
              style="width: 240px; margin-right: 8px"
            />
            <el-button size="mini" type="primary" @click="quickSelectTag">
              批量选中
            </el-button>
          </div>

          <!-- 标签树 -->
          <div
            v-if="group_value"
            style="height: 442px; overflow-y: auto; width: 300px"
          >
            <div class="choiceofficialaccount" style="margin-top: 10px">
              标签组
            </div>
            <el-tree
              ref="tree"
              :data="data"
              show-checkbox
              default-expand-all
              node-key="tag_id"
              highlight-current
              :props="defaultProps"
            >
              <template #default="{ node, data: item }">
                <span>{{ getLabelByLevel(node, item) }}</span>
              </template>
            </el-tree>
          </div>
        </div>
      </el-form-item>

      <el-form-item label="发送时间">
        <el-date-picker
          v-model="form.sendtime"
          :picker-options="pickerOptions"
          :clearable="false"
          type="datetime"
          placeholder="选择日期时间"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
        />
      </el-form-item>
      <el-form-item label="朋友圈编号">
        <el-tag
          v-if="form.sp_moments_no != ''"
          style="margin-right: 10px"
        >{{ title }}({{ form.sp_moments_no }})</el-tag>
        <el-button
          type="primary"
          size="mini"
          @click="choofriend"
        >选择朋友圈编号</el-button>
      </el-form-item>
      <div class="sava_box">
        <el-button size="mini" type="primary" @click="goback">返回</el-button>
        <el-button
          v-if="reuse || this.$route.query.type === 1"
          size="mini"
          type="primary"
          @click="sumbit"
        >保存</el-button>
      </div>
    </el-form>
    <el-dialog
      title="选择员工"
      :visible.sync="dialogVisibler"
      :append-to-body="true"
      :close-on-click-modal="false"
    >
      <bandstaff ref="bandstaffview" @bandarr="bandarr" />
    </el-dialog>
    <el-dialog
      title="选择朋友圈"
      :visible.sync="frienddialogVisibler"
      :append-to-body="true"
      :close-on-click-modal="false"
    >
      <frienddialog ref="frienddialogview" @friendband="friendband" />
    </el-dialog>
  </div>
</template>

<script>
import bandstaff from './components/bandstaff.vue'
import frienddialog from './components/frienddialog.vue'
import {
  momentsPushpushCreate,
  momentsPushpushDetail,
  corpTag,
  momentsPushPushUpdate
} from '@/api/officialaccount.js'
export default {
  components: { bandstaff, frienddialog },
  data() {
    return {
      loading: false,
      name: '',
      form: {
        sp_push_title: '',
        corp_userid: [],
        sp_moments_no: '',
        sendtime: null // 发送时间
      },
      dialogVisibler: false,
      group_value: false,
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      data: [],
      quickTagInput: '', // 快捷筛选的输入框模型
      pickerOptions: {
        // 禁用当前日期之前的日期
        disabledDate(time) {
          // Date.now()是javascript中的内置函数，它返回自1970年1月1日00:00:00 UTC以来经过的毫秒数。
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      frienddialogVisibler: false,
      title: '',
      type: null,
      arr: [],
      sp_push_no: null,
      tags: [],
      reuse: false,
      sign: ''
    }
  },
  watch: {
    group_value(newVal) {
      if (newVal) {
        this.reloadTagTree()
      }
    },
    // 深度监控员工列表变化
    'form.corp_userid': {
      handler(newList) {
        if (!this.group_value) return

        // 如果员工被删空
        if (newList.length === 0) {
          this.group_value = false
          this.clearTagTree()
        } else {
          this.reloadTagTree()
        }
      },
      deep: true
    }
  },
  created() {
    this.type = Number(this.$route.query.type)
    if (this.$route.query.reuse !== undefined) {
      this.sign = this.$route.query.reuse
      this.reuse = true
    }
    if (this.type === 2) {
      this.sp_push_no = this.$route.query.sp_push_no
      // console.log('this.sp_push_no :', this.sp_push_no)
      this.detail()
    }
  },
  mounted() {},
  methods: {
    async detail() {
      const data = await momentsPushpushDetail({
        sp_push_no: this.sp_push_no
      })
      this.form.sp_push_title = data.data.moments_push_data.sp_push_title
      this.form.sp_moments_no = data.data.moments_push_data.sp_moments_no
      this.form.corp_id = data.data.moments_push_data.corp_id
      this.name = data.data.moments_push_data.corp_name
      this.form.sendtime = data.data.moments_push_data.send_time
      this.title = data.data.msg_data.message_name
      this.form.corp_userid = data.data.bind_info
      this.tags = this.normalizeTagIds(data.data.moments_push_data.tag_id)
      if (this.tags.length) {
        this.group_value = true
      }
    },
    async bandarr(arr, sp_strategy_no, arrname) {
      this.dialogVisibler = false
      this.form.corp_userid = arr
      console.log(arr)
    },
    chorwe() {
      this.dialogVisibler = true
      this.$nextTick(() => {
        this.$refs.bandstaffview.sendr(this.form.corp_id, this.form.corp_userid)
      })
    },
    // 获取所有的子集
    fnTree(arr) {
      // 取树状数据的所有子集
      return arr.reduce((prev, cur) => {
        return prev.concat(
          cur.children && cur.children.length ? this.fnTree(cur.children) : cur
        )
      }, [])
    },
    async sumbit() {
      if (this.form.sp_push_title === '') {
        this.$message.error('请输入自有标题')
        return
      }
      if (this.form.corp_userid.length === 0) {
        this.$message.error('请选择企业员工')
        return
      }
      if (this.form.sendtime === null) {
        this.$message.error('请选择发送时间')
        return
      }
      if (this.form.sp_moments_no === '') {
        this.$message.error('请选择朋友圈编号')
        return
      }
      if (this.group_value && this.$refs.tree.getCheckedNodes().length === 0) {
        this.$message({
          message: '请选择标签',
          type: 'error'
        })
        return
      }
      this.arr = []
      this.arr = this.form.corp_userid.map((item) => {
        return item.employee_no
      })
      if (this.sign === 'edit') {
        await momentsPushPushUpdate({
          sp_push_title: this.form.sp_push_title,
          sp_moments_no: this.form.sp_moments_no,
          send_time: this.form.sendtime,
          relation_ids: this.arr,
          tag_id: this.group_value === true ? this.getGroupedTagIds() : [],
          sp_push_no: this.sp_push_no
        })
      } else {
        await momentsPushpushCreate({
          sp_push_title: this.form.sp_push_title,
          sp_moments_no: this.form.sp_moments_no,
          send_time: this.form.sendtime,
          relation_ids: this.arr,
          tag_id: this.group_value === true ? this.getGroupedTagIds() : []
        })
      }
      this.$message.success('发送成功!')
      this.$router.push({ path: '/circlefriends/index' })
    },

    clearTagTree() {
      this.data = []
      // 小防御：如果 tree 已经渲染，清空勾选
      if (this.$refs.tree) {
        this.$refs.tree.setCheckedKeys([])
      }
    },

    normalizeTagIds(tagId) {
      if (!tagId) return []
      if (!Array.isArray(tagId)) return [tagId]
      if (!tagId.length) return []
      if (typeof tagId[0] === 'string') return tagId
      return tagId.reduce((acc, item) => {
        if (item && Array.isArray(item.tag_ids)) {
          acc.push(...item.tag_ids)
        } else if (item && item.tag_id) {
          acc.push(item.tag_id)
        }
        return acc
      }, [])
    },
    // 加载并同步已选
    async reloadTagTree() {
      try {
        const prevKeys = this.$refs.tree ? this.$refs.tree.getCheckedKeys() : []
        // 编辑回填时树刚渲染，勾选还是空的，要用详情里的 tag_id
        const keysToApply = prevKeys.length ? prevKeys : this.tags || []

        await this.gettree()
        await this.$nextTick()

        if (!this.$refs.tree) return
        const validKeys = keysToApply.filter((key) =>
          this.isKeyInData(this.data, key)
        )
        this.$refs.tree.setCheckedKeys(validKeys)
      } catch {
        this.$message.error('刷新标签失败')
      }
    },

    // 判断某个 tag_id 是否还在当前 tree 里
    isKeyInData(tree, key) {
      return tree.some(
        (node) =>
          node.tag_id === key ||
          (node.children && this.isKeyInData(node.children, key))
      )
    },

    gettree() {
      return corpTag({
        corp_id: [...new Set(this.form.corp_userid.map((item) => item.corp_id))]
      })
        .then(async(res) => {
          this.data = res.data
          await this.$nextTick()
        })
        .catch(() => {
          this.$message.error('获取标签树失败')
        })
    },
    goback() {
      this.$router.push({ path: '/circlefriends/index' })
    },
    handleClose(index) {
      this.form.corp_userid.splice(index, 1)
    },
    choofriend() {
      this.frienddialogVisibler = true
    },
    friendband(item) {
      this.frienddialogVisibler = false
      this.form.sp_moments_no = item.sp_moments_no
      this.title = item.title
      console.log(item)
    },
    getLabelByLevel(node, data) {
      if (node.level === 1) {
        return data.corp_name
      } else if (node.level === 2) {
        return data.group_name
      } else if (node.level === 3) {
        return data.tag_name
      }
      return '未知'
    },
    getGroupedTagIds() {
      const checkedNodes = this.$refs.tree.getCheckedNodes()
      const groupedData = {}

      checkedNodes.forEach((node) => {
        if (node.tag_id && node.corp_id) {
          const corpId = node.corp_id

          if (!groupedData[corpId]) {
            groupedData[corpId] = []
          }
          groupedData[corpId].push(node.tag_id)
        }
      })

      const result = Object.keys(groupedData).map((corpId) => ({
        corp_id: corpId,
        tag_ids: groupedData[corpId]
      }))

      return result
    },
    findNodePath(tree, name, path = []) {
      for (const node of tree) {
        const currentPath = [...path, node]
        if (node.tag_name === name) {
          return currentPath
        }
        if (node.children && node.children.length) {
          const result = this.findNodePath(node.children, name, currentPath)
          if (result) return result
        }
      }
      return null
    },

    /**
     * 快捷筛选：输入标签名称后，自动勾选该标签及其父级节点
     */
    async quickSelectTag() {
      const input = this.quickTagInput.trim()
      if (!input) {
        this.$message.error('请输入要筛选的标签名称')
        return
      }

      // 如果树还没加载，则先打开并加载
      if (!this.group_value) {
        this.group_value = true
        await this.$nextTick()
        await this.gettree()
      }

      // 拆分多个标签名，支持英文逗号和中文逗号
      const names = Array.from(
        new Set(
          input
            .split(/[,，]/)
            .map((name) => name.trim())
            .filter((name) => name)
        )
      )

      const allKeys = []
      const notFound = []

      // 对每个名称，查路径并收集 tag_id
      for (const name of names) {
        const path = this.findNodePath(this.data, name)
        if (path) {
          allKeys.push(...path.map((node) => node.tag_id))
        } else {
          notFound.push(name)
        }
      }

      if (notFound.length) {
        this.$message.warning(`未找到标签：${notFound.join('、')}`)
      }

      if (allKeys.length) {
        // 去重后勾选
        const uniqueKeys = Array.from(new Set(allKeys))
        this.$refs.tree.setCheckedKeys(uniqueKeys)
      }
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.asdarw_box {
  padding: 30px;
}
.sava_box {
  position: fixed;
  bottom: 10px;
}

</style>
